<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <!-- no scripts in the letter: same origin only, so the page can edit it -->
  <iframe
    ref="frame"
    sandbox="allow-same-origin"
    :srcdoc="html"
    :title="title"
    :class="['anna-letter-editor', {'anna-letter-editor--readonly': readonly}]"
    @load="onLoad"
  ></iframe>
</template>

<script>
// A letter shown as it will look, typed into in place (the browser's own editing: designMode).
// The parent reads the edited letter with getHtml().
export default {
  name: 'LetterEditor',
  props: {
    html: {type: String, default: ''},
    title: {type: String, default: 'The letter'},
    readonly: {type: Boolean, default: false},
  },
  methods: {
    onLoad() {
      const doc = this.$refs.frame?.contentDocument;
      if (doc && !this.readonly) doc.designMode = 'on';
    },
    getHtml() {
      const doc = this.$refs.frame?.contentDocument;
      return doc ? `<!DOCTYPE html>\n${doc.documentElement.outerHTML}` : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.anna-letter-editor {
  width: 100%;
  height: 70vh;
  border: 1px solid #76bc21;
  border-radius: 8px;
  background: #fff;
}
.anna-letter-editor--readonly {
  height: 480px;
  border-color: #e8eaef;
}
</style>
